import { render, staticRenderFns } from "./ListTemplateMailPage.vue?vue&type=template&id=15f4e48b&"
import script from "./ListTemplateMailPage.vue?vue&type=script&lang=js&"
export * from "./ListTemplateMailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports